import dayjs, { type Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const utcDayStartIso = (value: Dayjs): string => value.utc().startOf('day').toISOString();

const utcDayEndIso = (value: Dayjs): string => value.utc().endOf('day').toISOString();

const dayjsUtcFromApiIso = (iso: string): Dayjs => dayjs.utc(iso).startOf('day');

const customUtcDaysToApiWindow = (from: Dayjs, to: Dayjs): { from: string; to: string } => ({
  from: utcDayStartIso(from),
  to: utcDayEndIso(to),
});

export { customUtcDaysToApiWindow, dayjsUtcFromApiIso, utcDayEndIso, utcDayStartIso };
